import { moveGroupOccurrenceText } from "./group-text.ts";

/**
 * Перенос занятия серии на другой день или час.
 *
 * Отдельным файлом от `EntryTools.tsx` с 30.08.2026, разбор повода в шапке
 * `EntryToolButtons.tsx`. Форма одна на пару и на группу: групповые ручки
 * принимают буквально то же тело запроса, поэтому второго набора полей даты и
 * времени в проекте не заводится, отличается только адрес и слова.
 */
export function MoveOccurrenceForm({
  students,
  zone,
  busy,
  toDate,
  toTime,
  onDate,
  onTime,
  onMove,
  onClose,
}: {
  /** Сколько человек задето, если это занятие группы. `null` у пары. */
  students: number | null;
  /** Зона СЕРИИ (у группы это зона её расписания), а не зона смотрящего. */
  zone: string;
  busy: boolean;
  toDate: string;
  toTime: string;
  onDate: (date: string) => void;
  onTime: (time: string) => void;
  onMove: () => void;
  onClose: () => void;
}) {
  return (
    <div className="form form--row">
      {students !== null && <p className="muted">{moveGroupOccurrenceText(students)}</p>}
      {/*
        Дата и время в зоне СЕРИИ, а не смотрящего: сервер принимает локальные
        значения серии, и подставлять сюда часы наблюдателя значило бы переносить
        занятие не туда, куда человек показал. У пучка зона общая, поэтому поле
        здесь то же самое
      */}
      <label className="field field--tight">
        <span className="lbl">Дата</span>
        <input className="fld" type="date" value={toDate} onChange={(e) => onDate(e.target.value)} />
      </label>
      <label className="field field--tight">
        <span className="lbl">Время</span>
        <input className="fld" type="time" value={toTime} onChange={(e) => onTime(e.target.value)} />
      </label>
      <button type="button" className="btn" disabled={busy || toDate === ""} onClick={onMove}>
        Перенести
      </button>
      <button type="button" className="btn btn--quiet" disabled={busy} onClick={onClose}>
        Не надо
      </button>
      {/*
        ⚠️ **Слова у группы свои, и это правка по итогам ревью 30.08.2026.**
        Форма стала общей, а строка осталась прежней и говорила группе неправду
        дважды: серии у группы нет, у неё расписание (так его зовут все соседние
        экраны), а подготовленного урока у занятия пучка не бывает вовсе, потому
        что своей комнаты у него пока нет (`group_room_unavailable`). Обещать
        переезд того, чего нет, хуже, чем промолчать: человек ищет обещанное и
        винит себя
      */}
      {students === null ? (
        <p className="muted">
          Время в зоне серии ({zone}). Занятие останется тем же: подготовленный урок, материал и
          доска переезжают вместе с ним.
        </p>
      ) : (
        <p className="muted">Время в зоне расписания группы ({zone}).</p>
      )}
    </div>
  );
}
